import { render, staticRenderFns } from "./AddOutForDeliveryDialog.vue?vue&type=template&id=08ff9480"
import script from "./AddOutForDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./AddOutForDeliveryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports